<template>
  <label :class="{ '--is-selected': isSelected }">
    <input
      class="radio-input"
      type="radio"
      :name="group"
      :value="value"
      :for="label"
      @change="handleClick"
    />
    <span class="radio-answer">
      <span class="value"> {{ value }}</span>
      <span class="text"> {{ label }}</span>
    </span>
  </label>
</template>

<script setup>
const props = defineProps({
  group: {
    type: [String, Object, Array],
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
  label: {
    type: String,
    default: "''",
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:checked']);
const handleClick = () => {
  emit('update:checked', props.value);
};
</script>

<style lang="scss" scoped>
label {
  width: 100%;
  margin-bottom: calc($padding-sml/2);
  font-size: $font-body;
  cursor: pointer;
}

.radio-input {
  position: absolute;
  visibility: hidden;

  &.--is-selected {
    background: red;
  }
}

.radio-answer {
  background: var(--input-background);
  border-radius: $border-radius;
  display: flex;
  flex-direction: row;
  align-items: start;
  padding: 1.5rem;

  .--is-selected & {
    background: rgba(255, 255, 255, 0.25);
  }

  .value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .text {
    margin-left: 1rem;
  }
}
</style>
